import trans from '@common/i18n/v1/trans'

import type { TNavbarButtonData } from '@zlt/components/Navbar/definitions'

import Navbar from '@zlt/components/Navbar/Navbar'

import router from '@mosolyteremto/router'

import './Menu.scss'

const ITEMS = [
  'main',
  'about',
  // 'postpartum',
  'request',
  // 'recommendation',
  'contact'
] as const

export type TMenuItem = typeof ITEMS[number]

type TOnclicks = {
  readonly [key in TMenuItem]: TVoidCallback
}

const ONCLICKS: TOnclicks = {
  main:           () => router.push('/'),
  about:          () => router.push('/rolam'),
  // postpartum:     () => router.push('/gyermekagy'),
  request:        () => router.push('/felkeres'),
  // recommendation: () => router.push('/ajanlas'),
  contact:        () => router.push('/kapcsolat')
}

export default function Menu (): HTMLElement {
  const buttonData: TNavbarButtonData = ITEMS.map((item) => (
    {
      onClick: ONCLICKS[item],
      text: trans(`Menu.${ item }`)
    }
  ))

  return (
    <Navbar buttonProps={ buttonData } />
  )
}
